import * as React from "react";
import { Select, useId } from "@fluentui/react-components";
import type { SelectProps } from "@fluentui/react-components";

export interface CustomDropdownOption {
  value: string;
  label: string;
}

export interface CustomDropdownProps extends SelectProps {
  label: string;
  options: CustomDropdownOption[];
  placeholder?: string;
}

export const CustomDropdown: React.FC<CustomDropdownProps> = ({ label, options, placeholder, ...props }) => {
  const selectId = useId();
  return (
    <>
      <label htmlFor={selectId} style={{ fontWeight: 500, marginBottom: 4 }}>{label}</label>
      <Select id={selectId} {...props}>
        <option value="" disabled selected>{placeholder || `Select ${label}`}</option>
        {options.map(opt => (
          <option key={opt.value} value={opt.value}>{opt.label}</option>
        ))}
      </Select>
    </>
  );
};
